import { normalize, isRecent, isExpired } from './format';
import { STATE_BY_UF, REGIONS } from '@/data/states';

const DAY = 86400000;

export function filterCompanies(list, f = {}, categoryById = {}) {
  const q = normalize(f.q || '');
  return list.filter((c) => {
    if (f.uf && c.location.uf !== f.uf) return false;
    if (f.city && normalize(c.location.city) !== normalize(f.city)) return false;
    if (f.categoryId && c.categoryId !== f.categoryId && !(c.extraCategoryIds || []).includes(f.categoryId)) return false;
    if (f.businessType && c.businessType !== f.businessType) return false;
    if (q) {
      const hay = normalize([c.name, c.tagline, c.description, ...(c.services || []), ...(c.products || []), c.location.city, categoryById[c.categoryId]?.name].join(' '));
      if (!q.split(/\s+/).every((t) => hay.includes(t))) return false;
    }
    return true;
  });
}

export function sortCompanies(list) {
  return [...list].sort((a, b) => Number(b.sponsored) - Number(a.sponsored) || Number(b.featured) - Number(a.featured) || new Date(b.updatedAt) - new Date(a.updatedAt));
}

export const relevanceScore = (o, company) => {
  const ageDays = (Date.now() - new Date(o.publishedAt).getTime()) / DAY;
  let s = Math.max(0, 30 - ageDays) / 10;
  if (o.sponsored) s += 3;
  if (company?.plan === 'premium') s += 1;
  if (o.deadline && !isExpired(o.deadline)) s += 1;
  s += Math.min(3, (o.requirements || []).length) * 0.3;
  s += Math.min(5, (o.targetUfs || []).length) * 0.2;
  return s;
};

export function filterOpportunities(list, f = {}, companyById = {}) {
  const q = normalize(f.q || '');
  const periodMs = f.period ? Number(f.period) * DAY : 0;
  return list.filter((o) => {
    if (f.uf && o.location.uf !== f.uf && !(f.includeTargets && (o.targetUfs || []).includes(f.uf))) return false;
    if (f.city && normalize(o.location.city) !== normalize(f.city)) return false;
    if (f.categoryId && o.categoryId !== f.categoryId) return false;
    if (f.type && o.type !== f.type) return false;
    if (f.businessType && companyById[o.companyId]?.businessType !== f.businessType) return false;
    if (periodMs && Date.now() - new Date(o.publishedAt).getTime() > periodMs) return false;
    if (f.onlyRecent && !isRecent(o.publishedAt)) return false;
    if (q) {
      const hay = normalize([o.title, o.summary, o.description, ...(o.requirements || []), companyById[o.companyId]?.name, o.location.city].join(' '));
      if (!q.split(/\s+/).every((t) => hay.includes(t))) return false;
    }
    return true;
  });
}

export function sortOpportunities(list, sort = 'recentes', companyById = {}) {
  const arr = [...list];
  if (sort === 'relevantes') return arr.sort((a, b) => relevanceScore(b, companyById[b.companyId]) - relevanceScore(a, companyById[a.companyId]));
  if (sort === 'regiao') {
    return arr.sort((a, b) => {
      const ra = REGIONS.indexOf(STATE_BY_UF[a.location.uf]?.region);
      const rb = REGIONS.indexOf(STATE_BY_UF[b.location.uf]?.region);
      return ra - rb || a.location.uf.localeCompare(b.location.uf) || new Date(b.publishedAt) - new Date(a.publishedAt);
    });
  }
  return arr.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
}

/** Lê/escreve filtros em URLSearchParams. */
export const FILTER_KEYS = ['uf', 'city', 'categoryId', 'businessType', 'type', 'period', 'q', 'sort'];
export const paramsToFilters = (sp) => Object.fromEntries(FILTER_KEYS.map((k) => [k, sp.get(k) || '']));
export const filtersToParams = (f) => {
  const out = {};
  FILTER_KEYS.forEach((k) => {
    if (f[k]) out[k] = f[k];
  });
  return out;
};
